var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _radialGradient, _linearGradient6, _radialGradient2, _filter, _linearGradient7, _linearGradient8, _radialGradient3, _linearGradient9, _linearGradient10, _filter2, _linearGradient11, _linearGradient12, _linearGradient13, _radialGradient4, _linearGradient14, _linearGradient15, _linearGradient16, _filter3, _filter4, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _g3, _path12, _g4, _path13, _path14, _g5, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#643400",
    viewBox: "-15.5 -16 544 544",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c59641",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edd19d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edd19d",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743800",
    stopOpacity: 0.55
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b6534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6a556",
    stopOpacity: 0
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 140.81,
    x2: 411.91,
    y1: 779.75,
    y2: 413.83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 187.76,
    cy: 978.43,
    gradientTransform: "matrix(1.0364 .564 -.4094 .7524 398.38 139.46)",
    r: 35.25,
    xlinkHref: "#d"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 182.26,
    x2: 229.5,
    xlinkHref: "#c",
    y1: 723.84,
    y2: 723.84
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 312.26,
    cy: 720.23,
    gradientTransform: "matrix(5.487 -.6915 .0685 .5437 -1446.5 542.55)",
    r: 39.32,
    xlinkHref: "#c"
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "i",
    height: 1.97,
    width: 2.01,
    x: -0.5,
    y: -0.49
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.04
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientTransform: "matrix(1.1538 .043 -.0464 1.2413 20.04 -254)",
    x1: 248.86,
    x2: 123.42,
    xlinkHref: "#d",
    y1: 966.34,
    y2: 1014.9
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 222.41,
    x2: 317.54,
    y1: 979.53,
    y2: 730.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#784421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deb15a"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 210.9,
    cy: 744.08,
    gradientTransform: "matrix(1 0 0 .7903 0 156.04)",
    gradientUnits: "userSpaceOnUse",
    r: 24.99
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d4e6"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 185.43,
    x2: 214.07,
    y1: 216.44,
    y2: 216.44
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4aa9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4aa9ff",
    stopOpacity: 0.27
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 193.34,
    x2: 208.4,
    y1: 225.17,
    y2: 209.99
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37a3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8e2e6"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "o"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.92
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: -12.03,
    x2: 373.74,
    y1: 1143.9,
    y2: 657.19
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1483ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#beddff",
    stopOpacity: 0
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 358.84,
    x2: 297.43,
    xlinkHref: "#b",
    y1: 719.31,
    y2: 759.44
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 114.76,
    x2: 148.75,
    xlinkHref: "#a",
    y1: 772.6,
    y2: 793.65
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 187.76,
    cy: 978.43,
    gradientTransform: "matrix(-1.0364 .564 .4094 .7524 125.75 133.54)",
    r: 35.25,
    xlinkHref: "#d"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientTransform: "matrix(-1.1538 .043 .0464 1.2413 504.09 -259.92)",
    x1: 248.86,
    x2: 123.42,
    xlinkHref: "#d",
    y1: 966.34,
    y2: 1014.9
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientTransform: "matrix(3.23 4.1875 -2.9528 2.83 2114.7 -1857)",
    x1: 127.72,
    x2: 143.93,
    xlinkHref: "#a",
    y1: 767.61,
    y2: 796.84
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 359.57,
    x2: 295.53,
    xlinkHref: "#b",
    y1: 724.99,
    y2: 762
  })), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "w"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.32
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "x",
    height: 1.33,
    width: 1.09,
    x: -0.05,
    y: -0.17
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m226.97 158.77c15.44 0 34.96 2.47 47.73 9.4 7.1-3.4 18.34-1.23 26.9-2.9 37.9-7.45 59.97-5.1 66.7 15.57 4.14 12.76 5.94 37.94-8.1 51.63 1.45 3.97 7.95 26.83 7.57 29.04-6.55 38.54-34.8 39.06-51.2 48.58-5.5 5.9-3.12 20.86-.82 26.28 5.76 12.25 32.63 53.5 36.47 65.43 22 68.2 23.18 23.1-4.93 48.77-132.27 120.87-165.35 22.52-204.06-59.87-22.93-48.8-9.15-87.82-3.46-122.48-16.9-2-33.6-19.67-24.62-35.96 5.4-8.48 22.3-14.9 32.8-15.18 13.5-35 40.27-58.3 79-58.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m232.63 700.38c14.35 0 30.87 3.84 42.74 10.56 6.6-3.3 15.68-4.67 23.6-6.45 35.53-8.03 63.45-2.84 68.73 20.62 3.27 14.52 4.58 35.86-10.55 47.3 3.1 2.3 8.2 28.1 7.28 31.76-6.4 25.03-18.4 28.18-49.7 43.6-5.1 5.72-5.67 22.6-3.53 27.85 5.35 11.87 31.95 50.1 35.53 61.64 20.45 66.02 20.6 23.56-5.5 48.42-122.93 117-153.68 20.82-189.66-58.9-21.32-47.26-13.16-86.95-7.87-120.5-15.7-1.96-33.77-16.14-25.44-31.9 5.03-8.2 20.97-14.67 30.72-14.94 12.57-33.88 47.66-59.12 83.65-59.12z",
    fill: "url(#k)",
    transform: "translate(0 -540.36)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m151.5 272.98c-16.9-2.02-45.3-24.43-36.33-40.72 5.42-8.47 22.75-13.65 33.24-13.93-1.4.4 20.73 5.02 7.9 2.8-26.4-4.55-41.64 11.9-40.26 24.6.43 3.98 10.73 13.76 15.6 15.53 16.67 6.06 18.37 6.13 19.87 11.72z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m345.57 999.88c-12.66 34.05-79.22 41.32-101.45 17.54-27.25-29.14-76.66-78.4-83.9-117 12.43-54.12 138.88-43.26 153.04.6 13.8 42.76 39.04 72.77 32.3 98.86z",
    fill: "url(#u)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.27 756.92c-1.3 3.54-5.2 11.65-8.96 13.9-2.17 1.32-1.76 1.9-1.83 1.27-.06-.6 1.52 3.37 2.23 5.04.68 1.64 5.9 21.5 5.04 26.6-1.24 7.34-6.87 18.63-10.48 20.08-13.96 5.6-39.75-11.22-56.26-11.22-31.2 0-62.5-42.85-62.5-66.74s62.55-42.75 93.75-42.75c19.8 0 25.64 2.86 35.3 15 6.5 8.2 6.75 30.56 3.72 38.83z",
    fill: "url(#q)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m221.42 240.6c1.18-6.27 16.94-8.4 14.12-8.18-6.5.5-8.6 2.84-8.24 3.5 4.07 7.36 16.03 38.4 56.84 26.97 9.58-2.7 19.2-3.33 24.5-8.08 14.74-13.2 18.6-19.6 25.23-27.8 1.3-1.6 2.9 1.1 8.36 4.4 1 .62 8.56.5 8.42-.82",
    style: {
      fill: "none",
      stroke: "#582d00",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.65,
      opacity: 0.2
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m360.26 767.22c-6.4.02-7.3-5.36-14.15-9-3.2-1.7-9.82-5.35-13.95-3.78-10.98 4.16-21.28 21.1-30.78 27.92-15.3 11-31.1 9.64-24.32 27.22 21.93 56.87-126.12 19.18 17.63 3.6-4-10.33 38.32-40.6 58.7-31.5 5.62 2.52 10.2 13.4 10.92 22.02 1.24 15.07-37.78 45.12-39.93 40.46-23.93-51.98-69.7-29.37-86.2-28.82-425.67 14.35-7.88-26.4-7.88-50.3 0-23.88 72.4-60.5 103.6-60.5 19.8 0 15.14-4.65 29.87 17.28 11.74 17.5 5.2 46.7-3.52 45.4z",
    fill: "url(#v)",
    filter: "url(#w)",
    transform: "translate(0 -540.36)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m324.72 199.7c23.25-12.02 50.53-39.63 21.4-42.76-.9-.1-13.07-.73-14.03-.78-42.13 1.48-60.05 11.1-57.2 16.22 8.7 15.65 21 28.9 49.8 27.32z",
    fill: "#733200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m5.63 809.4c0 154.9 99.63 258.16 250.17 258.16 61.1 0 119.27-22.54 163.63-64 50.9-47.27 77.82-112.72 77.82-189.8 0-82.18-30.55-152-86.54-200-44.35-37.8-97.43-56.72-159.97-56.72-67.64 0-124.36 21.1-170.17 63.27-49.46 45.84-74.9 109.83-74.9 189.1m246.53-205.81c79.26 0 147.75 77.8 147.75 212.34 0 128.72-69.22 207.26-149.2 207.26-77.83 0-148.5-78.55-148.5-212.36 0-130.17 69.22-207.26 149.94-207.26",
    fill: "url(#e)",
    stroke: "#0065d8",
    strokeMiterlimit: 1,
    strokeWidth: 3,
    transform: "matrix(1.0204 0 0 .98 0 -540.36)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m214.83 784.56c.68.83 4.23-6.96 7.6-7.9 5.44-1.52 20.4-6.12 21.83-5.3.92.55-16.37 6.52-15.83 7.34 9.03 13.43 10.7 31.1 42.5 26.97 36.37-3.9 38.04-6.74 63.72-38.66 1.7-2 20.33 12.5 22.83 10.55",
    fill: "none",
    filter: "url(#x)",
    opacity: 0.5,
    stroke: "#a05200",
    strokeWidth: 2.43,
    transform: "translate(0 -540.36)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m240.34 576.9c-72.63 1.3-145.5 39.54-182.62 102.85-33.62 58.07-38.78 129.05-25.38 193.85 12.9 64.1 54.22 123.08 114.26 150.65 75.53 35.8 171.44 31.43 239.66-18.95 48.2-35.35 80.5-90.94 88.02-150.22 9.9-67.3-3.9-140.15-46.2-194.34-33.62-43.78-84.8-73.6-139.58-81.27-15.87-2.5-32.08-2.7-48.16-2.56zm10.22 6.57c57.3-.8 110.42 36.57 135.78 86.8 34 62.4 39.52 137 28.43 206.32-9.84 55.24-37.1 110.02-84.25 142.24-43.86 29.68-105.72 33.22-150.86 4.37-47.37-28.32-76.45-79.7-88.32-132.6-15.92-66.64-11.8-138.8 14.63-202.15 20.14-45.64 58.04-85.92 107.12-99.5a145.56 145.56 0 0 1 37.44-5.47z",
    fill: "url(#p)",
    filter: "url(#o)",
    transform: "matrix(1.0204 0 0 .98 0 -540.36)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m204.8 957.6c-15.96-14.67-29.1 2.07-35.74 11.35-3.3 6.24-5.26 8.62-14.35 28.76-2.72 6.7-9.22 18.2-1.76 21 7.7 4.66 27.03-38.6 25.42-38.6-1.3 0-27.46 29.74-19.98 41.67 12.22 19.48 27.62-34.1 26.16-33.9-1.28.2-24.34 35.85-12 41.8 2.8 1.18 4.68-.7 7.76-3.25 9.6-4.96 24.22-15.37 26.5-21.5.7-3.08-25.9 15.82-26.1 20.56-.33 9.75 5.87 8.8 11.37 4.6 10.52-8 25.3-30.27 25.2-32.48 4.93-10.4 7.16-19.44 6.86-27.8-.18-5.1-11.36-10.98-19.32-12.18z",
    fill: "#000",
    filter: "url(#i)",
    opacity: 0.46,
    transform: "matrix(1.0145 .2397 -.088 .498 79.47 -64.69)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m204.8 417.24c-15.96-14.67-29.1 2.07-35.74 11.35-3.3 6.22-5.26 8.6-14.35 28.74-2.72 6.7-9.22 18.18-1.76 20.96 7.7 4.68 27.03-38.58 25.42-38.58-1.3 0-27.46 29.75-19.98 41.68 12.22 19.48 27.62-34.1 26.16-33.9-1.28.2-24.34 35.85-12 41.8 2.8 1.18 4.68-.7 7.76-3.25 9.6-4.97 24.22-15.38 26.5-21.52.7-3.07-25.9 15.83-26.1 20.57-.33 9.75 5.87 8.8 11.37 4.6 10.52-8 25.3-30.27 25.2-32.48 4.93-10.4 5.66-17.44 5.36-25.8-.18-5.1-9.86-12.98-17.82-14.18z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220.2 977.82c.5-2.74-6.45-16.58-16.65-15.78-10.07-13.83-21.37-5.35-22.43-3.98-16 17.03-15.36 24.6-24.8 34.85-5.16 5.6-4.44 12.2-4.33 16.18 0 .65.44 12.86 6.67 4.15 4.52-6.3 17.38-31.4 18.42-30.5 1.36 1.14-16.98 31.4-18.17 34.98-1.05 3.13 4.27 11.54 9.63 3.75 7.1-10.33 19.2-36.16 20.9-35.07 3.08 1.98-20.95 32.78-18.7 39 4.86 13.4 18.48-15.38 27.6-29.12 1.9-2.87 2.65-1.35 2.45-1-4.7 8.7-35.6 50.73-5.54 29.1 10.9-7.84 18.24-26.35 24.92-46.53z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.46 961.15c-26.85-29.06-45.65 23.48-56 45.73-3.82 8.23 1.67 15.98 7.4 6.8 4.5-6.32 17.2-31.84 18.24-30.97 1.37 1.18-17 31.44-18.16 35-1.05 3.2 4.27 11.8 9.63 3.75 6.95-10.42 19.2-36.15 20.9-35.07 3.08 2-20.95 32.8-18.7 39 4.86 13.42 18.48-15.37 27.6-29.12 1.9-2.86 2.66-1.34 2.45-.98-12.53 21.32-18.9 27.5-19.06 32.47 2.02 23.18 67.53-61.16 25.7-66.6z",
    fill: "url(#j)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m185.83 222.48c.54.74 3.83 1.94 17.16-.34 12.9-2.22 32.03-13 32.1-19.54.62-11.77-9.67-18.9-29.3-18.58-15.4.26-21.48 26.3-19.98 38.46z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m187.52 761.17c10.98 5 46.66-8.94 46.77-19.4 0-10.4-9.2-15.84-25.34-15.84s-21.45 24.82-21.45 35.24z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.1 738.05c22.98-11.47 40.77-32.97 16.14-36.47-20.62-4.24-28.85 2.64-43.4 6.56-22.02 4.64-23.02 1.46-20.7 4.83 9.46 13.7 18.22 26.14 47.97 25.08z",
    fill: "url(#h)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m221.46 240.2c.68.83-.2-2.4 2.98-3.9 4.9-2.3 6.6-3.57 8.32-3.66 11.18-.62-6.65-.43-4.45 2.7 8.66 12.27 15.67 37 56.5 26.12 9.57-2.56 18.56-3.56 23.85-8.08 14.74-12.6 17.62-19.92 24.26-27.75 1.3-1.52 3.2 1.02 8.8 3.96 1.8.94 7.74.73 8.35.24",
    fill: "none",
    stroke: "#582d00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m223.8 721.52c-17.8-12.83-28.1 6.3-41.54 13.44 4.07-18.24 32.76-29.66 47.16-16.66.83 1.08-4.4 3.02-5.63 3.22z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.96 768.33c24.5-5.84 18.55 2.12 21.36 9.2 3 7.58-.05 21.65-6.24 22.4-7.6.94-18.3-3.4-22.73-10.26-6.03-7.88-4.6-15.74 7.6-21.34z",
    fill: "url(#r)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m210.25 216.44c0 5.766-4.7 10.44-10.5 10.44s-10.5-4.674-10.5-10.44 4.7-10.44 10.5-10.44 10.5 4.674 10.5 10.44z",
    fill: "url(#n)",
    stroke: "url(#m)",
    strokeWidth: 2.9,
    transform: "matrix(.8946 0 0 .8454 39.03 17.65)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m319.32 411.32c15.97-14.67 29.1 2.07 35.75 11.35 3.3 6.24 5.26 8.62 14.35 28.76 2.74 6.7 9.24 18.18 1.78 20.96-7.7 4.65-27.03-38.6-25.42-38.6 1.3 0 27.46 29.74 19.98 41.67-12.22 19.48-27.62-34.1-26.16-33.9 1.28.2 24.34 35.85 12 41.8-2.8 1.18-4.68-.7-7.76-3.25-9.6-4.97-24.23-15.38-26.52-21.52-.7-3.06 25.9 15.84 26.1 20.58.34 9.75-5.86 8.8-11.36 4.6-10.52-8-25.3-30.27-25.2-32.48-4.93-10.4-5.66-17.44-5.36-25.8.18-5.1 9.86-12.98 17.82-14.18z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m303.93 971.9c-.52-2.74 6.44-16.58 16.64-15.78 10.07-13.83 21.37-5.35 22.43-3.98 16 17.03 15.36 24.6 24.8 34.85 5.16 5.56 4.44 12.2 4.33 16.14 0 .65-.46 12.86-6.7 4.15-4.5-6.3-17.37-31.4-18.4-30.5-1.38 1.13 16.96 31.4 18.15 34.97 1.05 3.12-4.27 11.53-9.63 3.74-7.1-10.32-19.2-36.15-20.9-35.06-3.08 1.98 20.95 32.78 18.7 39-4.86 13.4-18.48-15.38-27.6-29.13-1.9-2.85-2.65-1.33-2.45-.97 4.7 8.7 35.63 50.72 5.55 29.08-10.9-7.82-18.24-26.33-24.92-46.5z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.66 955.22c26.85-29.06 45.65 23.48 56 45.73 3.82 8.23-1.67 15.98-7.4 6.8-4.5-6.32-17.2-31.84-18.24-30.97-1.37 1.16 17 31.42 18.16 35 1.05 3.17-4.27 11.77-9.63 3.73-6.95-10.4-19.2-36.13-20.9-35.05-3.08 2 20.95 32.8 18.7 39-4.86 13.42-18.48-15.37-27.6-29.12-1.9-2.86-2.66-1.34-2.45-.98 12.53 21.32 18.9 27.5 19.06 32.47-2.02 23.2-67.53-61.15-25.7-66.58z",
    fill: "url(#t)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m291.56 205.04-2.5 1.1-2.72 1.14-4.02 1.88-3.42 1.56a43.38 43.38 0 0 0 -3.2 1.6l-4.07 2.25-5.63 3.14-7.22 4.18-5.1 3.05c-1.07.66-1.93 1.3-2.83 1.96l-1.78 1.23 2.14-2.05 1.75-1.22 2.9-1.97 5.08-3 7.26-4.2 5.65-3.17 4.14-2.3 3.3-1.62 3.4-1.54 4.04-1.88 2.74-1.18 2.5-1.1-2.4 2.14zm5-1.4-2.14 1.3-2.3 1.38-3.34 2.2-2.85 1.82-2.62 1.83-3.16 2.53-4.42 3.5-5.58 4.64-3.88 3.36c-.8.73-1.4 1.4-2.03 2.1-.38.44-.8.88-1.26 1.32l1.24-2.07 1.24-1.3 2.12-2.13 3.88-3.32 5.62-4.64 4.44-3.55 3.23-2.56 2.7-1.87 2.84-1.82 3.36-2.2 2.32-1.4 2.13-1.3-1.5 2.2zm5.4.96-2.14 1.28-2.3 1.38-3.34 2.2-2.85 1.82-2.62 1.83-3.16 2.56-4.42 3.5-5.58 4.63a94.66 94.66 0 0 0 -3.88 3.35c-.8.73-1.4 1.42-2.03 2.1l-1.26 1.33 1.24-2.08 1.24-1.3 2.1-2.14 3.9-3.3 5.62-4.66 4.43-3.55 3.23-2.58 2.7-1.86 2.84-1.8 3.36-2.2 2.32-1.4 2.12-1.3-1.5 2.2zm7.32-1.76-1.62 1.42-1.75 1.52-2.44 2.37-2.12 2c-.67.62-1.3 1.28-1.86 1.95l-2.12 2.65-2.93 3.67a189.2 189.2 0 0 0 -3.63 4.8l-2.45 3.48c-.5.75-.8 1.43-1.1 2.12l-.7 1.33.28-2 .66-1.3c.3-.7.63-1.4 1.14-2.15l2.47-3.43 3.66-4.82 2.94-3.7 2.16-2.7c.6-.7 1.24-1.37 1.94-2l2.1-2 2.5-2.37a43.3 43.3 0 0 1 1.76-1.55l1.6-1.43-.48 2.14zm2.02 1.54c-.43.46-.8.97-1.2 1.45l-1.3 1.57-1.75 2.4-1.52 2.04a14.1 14.1 0 0 0 -1.27 1.98l-1.28 2.64-1.78 3.65-2.1 4.78-1.35 3.42c-.26.73-.32 1.38-.4 2.04a13.58 13.58 0 0 1 -.26 1.3l-.43-1.86c.1-.43.16-.85.22-1.27.1-.65.2-1.32.46-2.06.38-1.1.9-2.25 1.38-3.4l2.12-4.77 1.77-3.7 1.3-2.67a17.7 17.7 0 0 1 1.33-2.03l1.52-2.03 1.75-2.42 1.3-1.6 1.2-1.45.25 2zm-18.52-2.03-5.58 1.87-4.34 1.6-3.67 1.34-3.5 1.38-4.53 2-6.25 2.8-8.06 3.7-5.72 2.74-3.28 1.8-2.05 1.14 2.66-1.95 2-1.13a60.3 60.3 0 0 1 3.36-1.8l5.68-2.7 8.12-3.73 6.3-2.8 4.58-2.04 3.6-1.4 3.66-1.32 4.36-1.6 5.63-1.92-2.97 2.05zm62.76-12.95c.62 0 1.28.08 1.92.1l2.07.12 3.16.37a50.95 50.95 0 0 1 5.2.65l3.4.84 4.68 1.15 6.1 1.65 4.34 1.32c.93.3 1.74.7 2.57 1.06l1.6.67-2.25-1.5-1.58-.68a23.5 23.5 0 0 0 -2.6-1.05l-4.32-1.26-6.1-1.65-4.74-1.16-3.43-.85a18.04 18.04 0 0 0 -2.63-.4l-2.66-.28-3.17-.35-2.1-.12-1.92-.14 2.44 1.5zm-3.42.7 1.83.57 1.97.6 2.95 1.1 2.5.88a20.37 20.37 0 0 1 2.38 1l3.06 1.6 4.25 2.23 5.46 3.04 3.87 2.3c.83.5 1.5 1.07 2.22 1.63l1.37 1.03-1.77-2-1.37-1.02-2.25-1.63-3.85-2.24a211.73 211.73 0 0 0 -5.48-3.07l-4.27-2.25a84.18 84.18 0 0 0 -3.1-1.65l-2.45-1-2.5-.9-2.96-1.08-2-.6-1.83-.6 1.98 2.03zm-2.4 3.85 1.84.57 1.96.6 2.96 1.1 2.5.88a20.37 20.37 0 0 1 2.38 1l7.3 3.83 5.46 3.04 3.87 2.3c.82.5 1.5 1.07 2.2 1.63l1.4 1.03-1.8-2-1.35-1.02-2.26-1.6-3.85-2.25-5.5-3.05-4.25-2.27-3.12-1.63c-.8-.38-1.63-.73-2.44-1l-2.5-.9-2.96-1.08-2-.62-1.83-.58 1.98 2.03zm-4.85 1.43 1.62.98 1.73 1.03 2.58 1.74 2.2 1.45c.7.44 1.38.97 2.04 1.52l2.55 2.28 3.5 3.17 4.5 4.24 3.17 3.15c.66.7 1.18 1.4 1.72 2.1.32.46.7.9 1.06 1.34l-1.2-2.36-1.05-1.32-1.76-2.1-3.15-3.08-4.53-4.26-3.55-3.2-2.6-2.3c-.68-.57-1.38-1.1-2.1-1.56l-2.18-1.44-2.6-1.76-1.76-1.07-1.63-1 1.4 2.45zm-.27 2.92c.48.37.94.82 1.42 1.23l1.53 1.3 2.22 2.18 1.9 1.8c.6.57 1.17 1.2 1.72 1.86l2.07 2.68 2.9 3.7 3.67 4.93 2.53 3.62c.53.8.9 1.57 1.3 2.36l.83 1.5-.75-2.54a29.7 29.7 0 0 1 -.8-1.46c-.4-.8-.8-1.6-1.35-2.38l-2.54-3.57-3.7-4.94-2.9-3.75-2.12-2.7-1.8-1.9-1.88-1.8-2.23-2.14-1.55-1.35-1.4-1.24.92 2.64zm8.85-11.68c.62-.1 1.3-.12 1.92-.2l2.07-.2 3.18-.14 2.68-.14c.84-.06 1.73-.04 2.6 0l3.5.3 4.83.4 6.3.67 4.52.63c.97.16 1.84.4 2.72.65l1.7.4-2.46-1.13-1.66-.42-2.76-.62-4.47-.55-6.32-.68-8.44-.72a26.22 26.22 0 0 0 -2.66 0l-2.67.17-3.2.15-2.1.2-1.9.17 2.66 1.1z",
    fill: "#bb8e4d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtter);
export default __webpack_public_path__ + "static/media/otter.67393c76fcdf5c0dced94e6ee1ac256a.svg";
export { ForwardRef as ReactComponent };